import { render, staticRenderFns } from "./prize-detail.vue?vue&type=template&id=0ddffc81&scoped=true&"
import script from "./prize-detail.vue?vue&type=script&lang=js&"
export * from "./prize-detail.vue?vue&type=script&lang=js&"
import style0 from "./prize-detail.vue?vue&type=style&index=0&id=0ddffc81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddffc81",
  null
  
)

export default component.exports